<template>
  <div :class="$style.modal">
    <div :class="$style.modalContent">
      <ModalHeader
        headerText="Validating Application Details"
        :showClose="false"
      />
      <div :class="$style.customModalBody">
        <p>It may take a minute or two to verify the URL for your custom app.</p>
        <div :class="$style.loadingIcon">
          <LoadingIcon :large="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingIcon from 'components/LoadingOverlay/LoadingIcon.vue';
import ModalHeader from 'client/components/Modal/ModalComponents/ModalHeader.vue';

export default {
  name: 'CustomAppsValidationUrlModal',

  components: {
    LoadingIcon,
    ModalHeader,
  },
};
</script>

<style module>
@import "../components/Modal/css/ModalStyles.css";

.customModalBody {
  flex-shrink: 1;
  font-size: 1.1em;
  font-weight: 400;
  padding: 0 35px;
}

.loadingIcon {
  align-items: center;
  display: flex;
  height: 200px;
  justify-content: center;
}
</style>
